export class BottomSheetConstants {
  public static readonly OVERLAY_PANEL_CLASS = 'iad-bottom-sheet-overlay';
}
